import { CustomerType, UserRole } from 'api/graphql';

/**
 * Joglo admins always may manage resource categories (teams).
 * Enterprise company admins may manage the system-wide catalog and assignments
 * for their company.
 */
export const canManageResourceCategories = (
  role?: UserRole | null,
  customerType?: CustomerType | null
): boolean => {
  if (role === UserRole.Admin) {
    return true;
  }

  return (
    role === UserRole.CompanyAdmin && customerType === CustomerType.Enterprise
  );
};
